import { render } from "./ToggleButtonBigger.vue?vue&type=template&id=022cc9af&scoped=true"
import script from "./ToggleButtonBigger.vue?vue&type=script&lang=js"
export * from "./ToggleButtonBigger.vue?vue&type=script&lang=js"

import "./ToggleButtonBigger.vue?vue&type=style&index=0&id=022cc9af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022cc9af"]])

export default __exports__